import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TextButton, Typography, Icon } from 'bonfire-kindling';
import { Page, Container } from 'components';

const GetStarted = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <Container sx={{ '& > * + *': { marginTop: theme => `${theme.spacing(3)} !important` } }}>
        <Icon
          color="primary"
          iconName="smile"
          iconStyle="far"
          mr={1}
          mt={5}
          style={{
            fontSize: '2.5rem',
          }}
        />
        <Typography component="h1" variant="h1" sx={{ fontSize: '1.5rem' }}>
          {t('get_started.congratulations')}
        </Typography>
        <Typography variant="body2" component="h2" sx={{ fontWeight: '600' }}>
          {t('get_started.welcome')}
        </Typography>
        <Typography variant="body2">{t('get_started.questions')}</Typography>
        <TextButton
          color="primary"
          variant="contained"
          component={Link}
          to="/welcome"
          label={t('get_started.action')}
        />
      </Container>
    </Page>
  );
};

export default GetStarted;
